import styled from "styled-components";
import { mainRed } from "../../style/colors";

export const ErrorContainer = styled.span`
    color: ${mainRed}
`